export default __webpack_public_path__ + "static/media/hero3.57b23370.jpg";